import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { getStoreDetails } from '../../ApiServices/StoreServices';
import { t } from 'i18next';

export const initialState = {
  value: {},
  loading: false,
  error: null,
};

const storeSlice = createSlice({
  name: 'store',
  initialState: initialState,
  reducers: {
    clearStoreState(state: any) {
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStoreDetails.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.value = action?.payload?.data;
    });
    builder.addCase(fetchStoreDetails.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = initialState.loading;
      state.value = initialState?.value;
    });
  },
});

export const storeState = (state: RootState) => state?.store;
export const { clearStoreState } = storeSlice.actions;
export default storeSlice.reducer;

export const fetchStoreDetails = createAsyncThunk(
  'store/fetchStoreDetails',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_STORES_DETAILS') }));
      return fulfillWithValue(await getStoreDetails());
    } catch (error: any) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
